import { Box, Button } from '@mui/material';
import { useCallback, useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import GameList from '../../components/GameManagement/GameLIst';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { getGamesRequest } from '../../redux/actions/getGameManagement';

function GameManagement(props) {

  const limit = 10;
  const [fetchedPages, setFetchedPages] = useState(new Set());
  const [currentPage, setCurrentPage] = useState(1);
  const [gameData, setGameData] = useState([]);
  const [showAddGameDialog, setShowAddGameDialog] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const passedState = location.state;
  const isNestedRoute = location.pathname !== "/game-management";
  const didRunOnce_BACK_GAME_MANAGEMENT = useRef(false);

  const [originalGamesList, setOriginalGamesList] = useState(props?.GAMES_DATA || []);
  const [paginationData, setPaginationData] = useState(props?.GAMES_PAGINATION_DATA || {});
  const totalPages = paginationData?.totalPages;

  const scrollRef = useRef(null);

  const handleNext = () => {
    const nextPage = currentPage + 1;
    if (currentPage < totalPages && !fetchedPages.has(nextPage)) {
      setCurrentPage(nextPage);
      setFetchedPages(prev => new Set(prev).add(nextPage));
      props?.getGames({ page: nextPage, limit });
    }
  };

  const handlePrev = () => {
    const prevPage = currentPage - 1;
    if (currentPage > 1 && !fetchedPages.has(prevPage)) {
      setCurrentPage(prevPage);
      setFetchedPages(prev => new Set(prev).add(prevPage));
      props?.getGames({ page: prevPage, limit });
    }
  };

  const handleScroll = useCallback(() => {
    const container = scrollRef.current;
    if (!container) return;

    const isBottom =
      container.scrollTop + container.clientHeight >= container.scrollHeight - 100;

    if (isBottom && currentPage < totalPages) {
      handleNext(); // load next page
    }
  }, [handleNext, currentPage, totalPages]);

  useEffect(() => {
    //console.log("passedState?.shouldRefresh : ", passedState?.shouldRefresh)
    //const shouldFetch = !fetchedPages.has(1) || (passedState?.shouldRefresh && !didRunOnce_BACK_GAME_MANAGEMENT.current);
    const shouldFetch = (passedState?.shouldRefresh && !didRunOnce_BACK_GAME_MANAGEMENT.current);
    //console.log("shouldFetch : ", shouldFetch)
    if (shouldFetch) {
      didRunOnce_BACK_GAME_MANAGEMENT.current = true;
      setFetchedPages(new Set([1])); // reset fetched pages
      setCurrentPage(1);
      props?.getGames({ page: 1, limit });
    }

    window.history.replaceState({}, document.title);
  }, [passedState])

  useEffect(() => {
    const container = scrollRef.current;
    if (container) container.addEventListener('scroll', handleScroll);
    //console.log("!fetchedPages.has(1) : ", !fetchedPages.has(1))
    //console.log("props?.GAMES_DATA?.length > 0 : ", props?.GAMES_DATA?.length > 0)
    if (
      !props?.GAMES_LOADING &&
      !props?.GAMES_ERROR &&
      currentPage === 1 &&
      !fetchedPages.has(1)
    ) {
      setFetchedPages(prev => new Set(prev).add(1));
      props?.getGames({ page: 1, limit });
      //console.log("api hit : ", 1)
    }

    if (props?.GAMES_DATA?.length > 0) {
      //console.log("api hit : ", 2)
      didRunOnce_BACK_GAME_MANAGEMENT.current = false;
      setGameData(props?.GAMES_DATA);
      setPaginationData(props?.GAMES_PAGINATION_DATA);
      setOriginalGamesList(props?.GAMES_DATA);
    }

    return () => {
      //setGameData([]);
      if (container) container.removeEventListener('scroll', handleScroll);
    };
  }, [
    props?.GAMES_PAGINATION_DATA,
    props?.GAMES_DATA,
    props?.GAMES_LOADING,
    props?.GAMES_ERROR,
    currentPage,
    handleScroll,
  ]);

  const navigateToUpdateGame = (_game_data) => {
    navigate('/game-management/create-modify-game', {
      state: {
        game_data: _game_data,
        from: 'GameManagement'
      }
    });
  };

  const handleDeleteGame = (gameId) => {
    props.deleteGame({
      id: gameId, callback: () => {
        setFetchedPages(new Set([1]));
        setCurrentPage(1);
        props?.getGames({ page: 1, limit });
      }
    });
  };

  const onItemClick = (index, item, gameData) => {
    navigateToUpdateGame(item);
  }

  return (
    isNestedRoute ? (
      <div style={styles.container}>
        <Outlet />
      </div>
    ) : (
      <div style={styles.container}>
        <Box sx={{ flex: 1, height: "100%", paddingTop: 4, marginTop: 2, }}>

          {/* Title + Create + Update button in a row */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 4,
            }}
          >
            <Box sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 0,
              px: 2
            }}>

            </Box>

            {/* Create */}
            <Box sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 0,
              px: 2
            }}>
              <Button
                variant="contained"
                color="success"
                sx={{ borderRadius: 2, textTransform: "none", px: 4 }}
                onClick={() => {
                  navigateToUpdateGame(null);
                }}
              >
                Create Game
              </Button>
            </Box>
          </Box>

          {<Box ref={scrollRef} sx={{
            height: '100vh',
            overflowY: 'auto',
            scrollbarWidth: 'none',       // Firefox
            msOverflowStyle: 'none',      // IE/Edge
            '&::-webkit-scrollbar': {     // Chrome/Safari
              display: 'none',
            },
          }}>
            <GameList gameData={props?.GAMES_DATA || []} onItemClick={onItemClick} />
          </Box>}
        </Box>
      </div>)
  );
}

const styles = {
  container: {
    padding: '40px',
    textAlign: 'center',
  },
};

const mapStateToProps = (state) => {
  return {
    GAMES_LOADING: state?.gameManagement?.games_loading,
    GAMES_ERROR: state?.gameManagement?.games_error,
    GAMES_DATA: state?.gameManagement?.games_data,
    GAMES_PAGINATION_DATA: state?.gameManagement?.games_meta,
  }
};

const mapDispatchToProps = {
  getGames: getGamesRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(GameManagement);
